<template>
  <div class="privacy">
    <MainNav />
    <div class="jumbotron jumbotron-fluid bg-light">
      <div class="container">
        <h1>Privacy Policy</h1>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col">
          <h3 class="text-center">
            The Environmental Record Centre for Cornwall and the Isles of Scilly
            Privacy Policy
          </h3>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col">
          <h3 class="text-center">
            Cornwall Wildlife Trust, or CWT: registered charity in England and
            Wales 214929.
          </h3>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col">
          <h3 class="text-center">
            The Environmental Record Centre for Cornwall and the Isles of Scilly
            or ERCCIS: Website -Privacy Policy
          </h3>
        </div>
      </div>

      <br />
      <!--- New Number --->
      <div class="row">
        <div class="col">
          <p>
            ERCCIS collates, manages and disseminates biological and geological
            information for use in research, conservation and sustainable
            development, working with local and national biological recorders
            and conservation organisations for the better environmental
            conservation of the county.
          </p>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col">
          <p>
            As a Local Environmental Record Centre, ERCCIS works to support and
            facilitate recording across Cornwall, through our
            <a
              href="https://erccis.org.uk/information-and-advice"
              target="_blank"
              >Wildlife Information Service</a
            >
            and online recording website
            <a href="https://erccis.org.uk/share-sightings" target="_blank"
              >ORKS -Online Recording Kernow and Scilly</a
            >
          </p>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col">
          <p>
            Information is received from a variety of sources and is stored in
            its original format and/or on computer databases.
          </p>
        </div>
      </div>

      <br />
      <div class="row">
        <div id="1" class="col-1"><h2>1.</h2></div>
        <div class="col-11"><h3>General</h3></div>
      </div>
      <div class="row">
        <div class="col">
          <p>
            We are committed to gathering and processing personal data with full
            regard for the General Data Protection Regulations (GDPR), the
            Privacy and Electronic Communications Regulations (PECR) and to the
            principles of personal choice and control, transparency, fairness
            and security. We always collect and process data on lawful grounds
            to meet the genuine needs of our organisation, but we do so with the
            highest regard for an individual’s rights and freedoms.
          </p>
        </div>
      </div>

      <br />
      <!--- New Number --->
      <div class="row">
        <div id="2" class="col-1"><h2>2.</h2></div>
        <div class="col-11"><h3>Why do we collect your personal data?</h3></div>
      </div>
      <div class="row">
        <div class="col">
          <p>
            We use your personal data to keep in touchwith you. Wewill only ever
            collect, store and use your personal data when we have an identified
            purpose and reason to do so.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p>
            The ICO
            <a href="https://www.ico.org.uk" target="_blank"
              >(www.ico.org.uk)</a
            >
            refers to this as a ‘lawful basis’. Further information about why we
            collect your personal data is outlined below.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p>
            The features of the ERCCIS website can be used without disclosing
            personal information.<br />However, if you would like to:
          </p>
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-11">
          <p>i) &nbsp;&nbsp;&nbsp; Subscribe to our newsletter</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            The ICO defines the lawful basis for processing your data for this
            purpose is opt-in consent where you have given us express permission
            to contact you by particular communication channels.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            We respect your right to update the way we get in touch with you at
            any time and will offer you the chance to unsubscribe throughout our
            correspondence.
          </p>
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-11">
          <p>ii) &nbsp;&nbsp;&nbsp; Volunteer with us</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            We will collect your personal data so that we can keep in touch with
            you about, for example:
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-10">
          <p>• &nbsp;&nbsp;&nbsp; the current work of CWT</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-10">
          <p>
            • &nbsp;&nbsp;&nbsp; changes to planned volunteer work programmes
            thatyou may be taking part in
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-10">
          <p>
            • &nbsp;&nbsp;&nbsp; the positive impact you have on our work, by
            sending you our volunteer newsletter or similar
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-10">
          <p>
            • &nbsp;&nbsp;&nbsp; events useful for volunteers e.g. training
            opportunities, ‘thank you’ events, informative events.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-10">
          <p>• &nbsp;&nbsp;&nbsp; new volunteer opportunities</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-10">
          <p>
            • &nbsp;&nbsp;&nbsp; thank you letters and information relating to
            our volunteer awards
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-10">
          <p>• &nbsp;&nbsp;&nbsp; Christmas cards, get well cards, etc.</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-10">
          <p>
            • &nbsp;&nbsp;&nbsp; feedback about your volunteering for example
            volunteer satisfaction surveys and exit reviews
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-10">
          <p>• &nbsp;&nbsp;&nbsp; your feedback about the work of CWT</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            The ICO define the lawful basisfor processing your data for these
            purposes as ‘contractual’ (where administering your volunteer
            record). Once your time as volunteer is over we will follow the
            lawful basis of consent as per 2(i).
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            We will respect your right to update the way we keep in contact and
            will offer you the chance to unsubscribe throughout our
            correspondence.
          </p>
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-11">
          <p>iii) &nbsp;&nbsp;&nbsp; Use our products and services</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            As referred in CWT Privacy Policy Section 4(d) we will hold your
            data to deliver any services that you have asked for. We collect
            personal data to:
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            We respect your right to update the way we get in touch with you at
            any time and will offer you the chance to unsubscribe throughout our
            correspondence.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-10">
          <p>
            • &nbsp;&nbsp;&nbsp; provide funded or charged services –such as
            landowner advice, environmental consultancy services and their
            affiliated agreements and all events and educational activities
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-10">
          <p>
            • &nbsp;&nbsp;&nbsp; process any payments related to these services
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-10">
          <p>
            • &nbsp;&nbsp;&nbsp; process any monitoring information related to
            these services
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            The ICO define the lawful basis for processing your data for these
            purposes as ‘contractual’. Where it is a contractual requirement to
            share your personal data with third parties –such as our funders or
            any regulatory bodies –we will always make this clear when we first
            collect information from you.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            We respect your right to update the way we get in touch with you at
            any time.
          </p>
        </div>
      </div>

      <br />
      <!--- New Number --->
      <div class="row">
        <div id="3" class="col-1"><h2>3.</h2></div>
        <div class="col-11"><h3>Biological records</h3></div>
      </div>

      <div class="row justify-content-end">
        <div class="col-11">
          <p>i) &nbsp;&nbsp;&nbsp; Submitting Biological records</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            The Online Recording Kernow and Scillyor ORKS is an online service,
            provided by ERCCIS that enablesanyone to upload a sighting or record
            of any flora and fauna in Cornwall. When a record is sent in, your
            name and email areheld on our biological database as part of your
            record. This is part of our verification process, where we check
            that the identification is correct. We may contact National or local
            experts, to ask for their opinion on records that are rare or
            difficult to identify. ERCCIS/CWT staff and our affiliated verifiers
            will have access to your personal contact information, and we may
            need to contact you specifically regarding you’re record.
          </p>
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-11">
          <p>ii) &nbsp;&nbsp;&nbsp; Requesting Biological records</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            If you want to request a data search from us then we need you to
            provide your company or personal contact details. We ask an enquirer
            to complete an Information request form, and may take up references
            before the data is supplied.These details will be used only to
            facilitate the processing of your data search.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            The ICO define the lawful basis for processing your data for this
            purpose as ‘consent’ where submission of records to ERCCIS by any
            means (including ORKS) will include the use of your personal
            information. We agree that your personal information will not be
            passed to any third party, and this does not affect your right to
            delete your ORKS account at any time.
          </p>
        </div>
      </div>

      <br />
      <!--- New Number --->
      <div class="row">
        <div id="4" class="col-1"><h2>4.</h2></div>
        <div class="col-11"><h3>How do we store your data?</h3></div>
      </div>

      <div class="row justify-content-end">
        <div class="col-11">
          <p>i) &nbsp;&nbsp;&nbsp; Security Biological records</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            All of the personal data we process is processed by our staff in the
            UK. However, for the purposes of IT hosting and maintenance your
            information may be situated outside of the European Economic Area
            (EEA). This will be done in accordance with guidance issued by the
            Information Commissioner’s Office.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            We use Mail Chimp for email correspondencefor ERCCIS related
            newsletters and updates. A copy of their policy regarding data
            security in terms of operational security, physical security and
            application security can be found on their website.
            <a href="http://www.mailchimp.com" target="_blank"
              >(www.mailchimp.com)</a
            >
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            Electronic data and databases are stored on secure computer systems
            and we control who has access to information (using both physical
            and electronic means). Our staff receive data protection training
            and we have a clear Data Protection Policy and associated guidance
            which personnel are required to follow when handling personal data
          </p>
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-11">
          <p>ii) &nbsp;&nbsp;&nbsp; Data retention policy</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            We will only use and store information for as long as it required
            for the purposes it was collected for. We continually review what
            information we hold and delete what is no longer required.
          </p>
        </div>
      </div>

      <br />
      <!--- New Number --->
      <div class="row">
        <div id="5" class="col-1"><h2>5.</h2></div>
        <div class="col-11"><h3>Data sharing</h3></div>
      </div>
      <div class="row">
        <div class="col">
          <p>
            We sometimes need to share the personal information we process.
            Where this is necessary we, and any third parties we share with, are
            required to comply with all aspects of the General Data Protection
            Regulations (GDPR). Sharing is always subject to a lawful basis for
            processing.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p>We will never sell personal details to third parties.</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p>Organisations that we share data with include:</p>
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            • &nbsp;&nbsp;&nbsp; Our partners on partnership projects –for
            example, for the purposes of project monitoring and delivery;
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            • &nbsp;&nbsp;&nbsp; Survey or research organisations –for example,
            to verify species records.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            • &nbsp;&nbsp;&nbsp; Our funders (if applicable) –to demonstrate
            compliance to funding and service provision contracts;
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            • &nbsp;&nbsp;&nbsp; Legal/compliance bodies where required
            –insurers, auditors, pension provider, HMRC, Fundraising Regulator,
            ICO;
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            • &nbsp;&nbsp;&nbsp; Statutory bodies or agencies –for example, to
            respond to legal issues and risks;
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            • &nbsp;&nbsp;&nbsp; Healthcare, social and welfare organisations
            –to manage and safeguard the wellbeing of our staff, volunteers and
            beneficiaries;
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            • &nbsp;&nbsp;&nbsp; Educators and examining bodies –for example,
            where we are supporting trainees;
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            • &nbsp;&nbsp;&nbsp; Current, past and prospective employers –for
            example, to provide references;
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            When we work with other organisations or individuals in this way, we
            must always set up a written contract with them to protect personal
            data –Data Processing and/or Data Sharing Agreements. The third
            parties we work with at no point ‘own’ an individual’s data, must
            never contact the individual outside of their agreement with us and
            must always delete this data from their systems when they have
            completed the task in hand. We must always send data to partner
            organisations securely, to minimise the risk of it being intercepted
            by unknown individuals and/or organisations.
          </p>
        </div>
      </div>

      <br />
      <!--- New Number --->
      <div class="row">
        <div id="6" class="col-1"><h2>6.</h2></div>
        <div class="col-11"><h3>Your rights</h3></div>
      </div>
      <div class="row">
        <div class="col">
          <p>
            We respect your right to control your data. Your rights include:
          </p>
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-11"><h4>a) The right to be informed:</h4></div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            This privacy notice outlines how we capture, store and use your
            data. If you have any questions about any elements of this policy,
            please contact us.
          </p>
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-11"><h4>b) The right of access:</h4></div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            If you wish to obtain a record of the personal data we hold about
            you, through a Subject Access Request, we will respond within one
            month. To make a Subject Access Request, please contact our Head of
            Finance & Administration.
          </p>
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-11"><h4>c) The right to rectification</h4></div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            If we have captured information about you that is inaccurate
            orincomplete, we will update it.
          </p>
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-11"><h4>d) The right to erase:</h4></div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            You can ask us to remove or randomise your personal details from our
            records.
          </p>
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-11"><h4>e) The right to restrict processing</h4></div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>You can ask us to stop using your personal data.</p>
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-11"><h4>f) The right to data portability</h4></div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            You can ask to obtain your personal data from us for your own
            purposes.
          </p>
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-11"><h4>g) The right to object</h4></div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>You can ask to be excluded from marketing activity.</p>
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-11">
          <h4>
            h) Rights in relation to automated decision making and profiling
          </h4>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            We respect your right not to be subject to a decision that is based
            on automated processing.
          </p>
        </div>
      </div>

      <br />
      <!--- New Number --->
      <div class="row">
        <div id="7" class="col-1"><h2>7.</h2></div>
        <div class="col-11"><h3>Making a complaint</h3></div>
      </div>
      <div class="row">
        <div class="col">
          <p>
            The Cornwall Wildlife Trust want to exceed your expectations in
            everything we do. However, we know that there may be times when we
            do not meet our own high standards. When this happens, we want to
            hear about it, to deal with the situation as quickly as possible and
            put measures in place to stop it happening again.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p>
            We take complaints very seriously and we treat them as an
            opportunity to improve and strengthen our relationship with our
            supporters and volunteers. This is why we are always very grateful
            to hear from people who are willing to take the time to help us
            improve.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col"><p>Our policy is:</p></div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            • &nbsp;&nbsp;&nbsp; To provide a fair complaints procedure that is
            clear and easy to use for anyone wishing to make a complaint.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            • &nbsp;&nbsp;&nbsp; To publicise the existence of our complaints
            procedure so that people know how to contact us to make a complaint.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            • &nbsp;&nbsp;&nbsp; To make sure everyone in our organisation knows
            what to do if a complaint is received.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            • &nbsp;&nbsp;&nbsp; To make sure all complaints are investigated
            fairly and in a timely way.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            • &nbsp;&nbsp;&nbsp; To make sure that complaints are, wherever
            possible, resolved and that relationships are repaired.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            • &nbsp;&nbsp;&nbsp; To learn from complaints and feedback to help
            us to improve what we do.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11"><p>• &nbsp;&nbsp;&nbsp; Confidentiality</p></div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            All complaint information will be handled sensitively, in line with
            relevantdata protection requirements.
          </p>
        </div>
      </div>

      <br />
      <!--- New Number --->
      <div class="row">
        <div id="8" class="col-1"><h2>8.</h2></div>
        <div class="col-11"><h3>Get in touch!</h3></div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            Should you wish to find out more about the information we hold about
            you, or about our privacy policy, please contact us:
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p>
            Data Protection Team<br />
            Telephone: +44 1872 302267<br />
            Email:
            <a href="mailto:info@cornwallwildlifetrust.org"
              >info@cornwallwildlifetrust.org</a
            ><br />
            Address: Cornwall Wildlife Trust<br />
            Five Acres<br />
            Allet<br />
            Truro<br />
            Cornwall<br />
            TR4 9DJ
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p>Our office hours are Monday –Friday 8:30am –4:30pm.</p>
        </div>
      </div>

      <br />
      <!--- New Number --->
      <div class="row">
        <div id="9" class="col-1"><h2>9.</h2></div>
        <div class="col-11"><h3>Cookies</h3></div>
      </div>
      <div class="row">
        <div class="col">
          <p>
            Our website uses cookies, as almost all websites do, to help provide
            you with the best experience we can. Cookies are small text files
            that are placed on your computer or mobile phone when you browse
            websites.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col"><p>Our cookies help us:</p></div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>• &nbsp;&nbsp;&nbsp; Make our website work as you'd expect</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            • &nbsp;&nbsp;&nbsp; Remember your settings during and between
            visits
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>• &nbsp;&nbsp;&nbsp; Improve the speed/security of the site</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            • &nbsp;&nbsp;&nbsp; Allow you to share pages with social networks
            like Facebook
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>• &nbsp;&nbsp;&nbsp; Continuously improve our website for you</p>
        </div>
      </div>

      <div class="row">
        <div class="col"><p>We do NOT use cookies to:</p></div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            • &nbsp;&nbsp;&nbsp; Collect any personally identifiable information
            (without your express permission)
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            • &nbsp;&nbsp;&nbsp; Collect any sensitive information (without your
            express permission)
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            • &nbsp;&nbsp;&nbsp; Pass personally identifiable data to third
            parties
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>• &nbsp;&nbsp;&nbsp; Pay sales commissions</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            • &nbsp;&nbsp;&nbsp; You can learn more about all the cookies we use
            at
            <a href="https://erccis.org.uk/aboutus/Policies"
              >erccis.org.uk/aboutus/Policies</a
            >
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            Most web browsers allow you to control how cookies are handled,
            whether they are accepted and how long they are stored for. To find
            out more about cookies, including howto see what cookies have been
            set and how to manage and delete them, visit
            <a href="http://www.allaboutcookies.org" target="_blank"
              >www.allaboutcookies.org</a
            >
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p>
            To opt out of being tracked by Google Analytics across all websites
            visit
            <a href="http://tools.google.com/dlpage/gaoptout" target="_blank"
              >tools.google.com/dlpage/gaoptout</a
            >
          </p>
        </div>
      </div>

      <br />
      <!--- New Number --->
      <div class="row">
        <div id="10" class="col-1"><h2>10.</h2></div>
        <div class="col-11"><h3>Notification of changes</h3></div>
      </div>
      <div class="row">
        <div class="col">
          <p>
            If the Cornwall Wildlife Trust decides to change their privacy
            policy it, will post any changes on their website, under the section
            entitled
            <a href="/privacy-policy" target="_blank">'Privacy Policy'</a>.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p>
            If ERCCIS decide to change their privacy policy it will post any
            changes on the website under the section entitled
            <a href="https://erccis.org.uk/aboutus/Policies" target="_blank"
              >'Policy and Procedures'</a
            >.
          </p>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import MainNav from "@/components/MainNav.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Privacy",
  components: {
    MainNav,
    Footer
  }
};
</script>
